<div class="stepper-wrapper">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{getDialogTitle()}}</h2>
    <button
      mat-icon-button
      class="dialog-close"
      aria-label="Close"
      data-test="dialog-close"
      (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if (copyConfig$ | async; as copyConfig) {
    <mat-horizontal-stepper [linear]="true" #stepper>
      <!-- Step 1: Copy Fund Report -->
      @if (startWith === 'report') {
        <mat-step label="Copy Fund Report">
          <valumize-fund-report-copy-dialog
            [fundId]="fundId"
            (completed)="stepper.next()">
          </valumize-fund-report-copy-dialog>
        </mat-step>
      }
      <!-- Step 2: Copy Fund Valuation -->
      <mat-step label="Copy Fund Valuation">
        <valumize-fund-valuation-copy-dialog
          [fundId]="fundId"
          [fundReportId]="copyConfig.fundReportCopyConfig?.fundReportId ?? fundReportId"
          (completed)="onNavigateToAssetValuationStep()"
          (previous)="stepper.previous()">
        </valumize-fund-valuation-copy-dialog>
      </mat-step>
      <!-- Step 3: Copy Asset Valuations -->
      @if (showCopyAssetValuationsStep) {
        <mat-step label="Copy Asset Valuations">
          <valumize-asset-valuation-copy-dialog
            #assetValuationCopyDialog
            [fundId]="fundId"
            [fundReportId]="copyConfig.fundReportCopyConfig?.fundReportId ?? fundReportId"
            (completed)="stepper.next()"
            (previous)="stepper.previous()">
          </valumize-asset-valuation-copy-dialog>
        </mat-step>
      }
      <mat-step label="Done">
        <h1 mat-dialog-title>Summary</h1>
        <mat-dialog-content>
          <div>
            @if (copyConfig.fundReportCopyConfig) {
              <h3>Report</h3>
              New Report Date: {{copyConfig.fundReportCopyConfig.reportDate | date}}
              <h3>Investments</h3>
              {{copyConfig.fundReportCopyConfig.fundInvestmentsCopyConfig.length}} Investments prepared to copy
            }
            @if (copyConfig.fundValuationCopyConfig) {
              <h3>Fund Valuation</h3>
              <div>New Closing Date: {{copyConfig.fundValuationCopyConfig.closingDate | date}}</div>
              <div>Description: {{copyConfig.fundValuationCopyConfig.description}}</div>
              @if (showCopyAssetValuationsStep) {
                <h3>Company Valuations</h3>
                {{copyConfig.fundValuationCopyConfig.assetValuationsCopyConfig.length}} Company Valuations prepared to copy
              }
            }
            @if (copyErrorMessage) {
              <div class="copy-error-message">{{copyErrorMessage}}</div>
            }
          </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button
            mat-stroked-button
            [disabled]="isCopying"
            (click)="stepper.previous()">
            Back
          </button>
          <button
            mat-stroked-button
            color="primary"
            [disabled]="isCopying"
            (click)="copy(copyConfig)">
            @if (isCopying) {
              <mat-spinner diameter="20"></mat-spinner>
            } @else {
              Copy
            }
          </button>
        </mat-dialog-actions>
      </mat-step>
    </mat-horizontal-stepper>
  }
</div>
